
(() => {
  const rootSelector = '[data-mega-menu-products]';
  const itemSelector = '[data-mega-menu-products-item]';
  const panelSelector = '[data-mega-menu-products-panel]';
  const groupSelector = '[data-mega-menu-products-group]';
  const accordionSelector = '.mega-menu-products__accordion';

  const getGroupKey = (itemKey) => (itemKey || '').split('-')[0] || '';

  const forceAccordionOpen = (accordion) => {
    if (!accordion) {
      return;
    }

    accordion.setAttribute('open', '');
    accordion.setAttribute('aria-expanded', 'true');

    if ('open' in accordion) {
      try {
        accordion.open = true;
      } catch (error) {
      }
    }
  };

  const syncGroups = (root, activeItemKey) => {
    const activeGroupKey = getGroupKey(activeItemKey);

    root.querySelectorAll(groupSelector).forEach((group) => {
      const isActive = group.dataset.megaMenuProductsGroup === activeGroupKey;
      const accordion = group.querySelector(accordionSelector);

      group.dataset.selected = isActive ? 'true' : 'false';

      if (accordion) {
        forceAccordionOpen(accordion);
      }
    });
  };

  const setActiveItem = (root, nextItem) => {
    if (!root || !nextItem) {
      return;
    }

    const nextPanelId = nextItem.getAttribute('aria-controls');
    const title = nextItem.dataset.title || '';
    const url = nextItem.dataset.url || '';

    root.dataset.activeItem = nextItem.dataset.itemKey || '';
    syncGroups(root, root.dataset.activeItem);

    root.querySelectorAll(itemSelector).forEach((item) => {
      item.setAttribute('aria-pressed', item === nextItem ? 'true' : 'false');
    });

    root.querySelectorAll(panelSelector).forEach((panel) => {
      panel.hidden = panel.id !== nextPanelId;
    });

    const titleElement = root.querySelector('[data-mega-menu-products-title]');
    const linkElement = root.querySelector('[data-mega-menu-products-link]');

    if (titleElement) {
      titleElement.textContent = title;
    }

    if (linkElement) {
      if (url && url !== '#') {
        linkElement.setAttribute('href', url);
      } else {
        linkElement.removeAttribute('href');
      }
    }
  };

  const initializeRoot = (root) => {
    syncGroups(root, root.dataset.activeItem || '');

    const activeItemKey = root.dataset.activeItem || '';
    const activeItem =
      Array.from(root.querySelectorAll(itemSelector)).find((item) => item.dataset.itemKey === activeItemKey) ||
      root.querySelector(itemSelector);

    setActiveItem(root, activeItem);
    window.requestAnimationFrame(() => {
      syncGroups(root, root.dataset.activeItem || '');
    });
  };

  const initializeAll = () => {
    document.querySelectorAll(rootSelector).forEach((root) => initializeRoot(root));
  };

  document.addEventListener('click', (event) => {
    const item = event.target.closest(itemSelector);

    if (!item) {
      return;
    }

    const root = item.closest(rootSelector);

    if (!root) {
      return;
    }

    event.preventDefault();
    setActiveItem(root, item);
  });

  document.addEventListener('mouseover', (event) => {
    const root = event.target.closest(rootSelector);

    if (!root) {
      return;
    }

    syncGroups(root, root.dataset.activeItem || '');
  });

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);

  if (document.readyState !== 'loading') {
    initializeAll();
  }
})();
